<template>
    <div class="venue-genre-popup-container">
        <popup-modal @setAction="handleSetAction" @cancelAction="handleCancelAction">
            <div class="popup-wrapper">
                <div class="venue-type-input">
                    <p class="title">Venue Genre</p>
                    <p class="subtitle">What best describes you?</p>
                    <div class="field-inputs">
                        <div
                            v-for="(type, indx) in venueTypes"
                            :key="type.name"
                            class="venue-type"
                        >
                            <input
                                v-model="type.selected"
                                :name="type.name"
                                :id="type.name"
                                @change="uncheckOthers(indx)"
                                class="form-check-input"
                                type="checkbox"
                            />
                            <label class="form-check-label" :for="type.name">{{
                                type.label
                            }}</label>
                        </div>
                        <div class="other-venue-type-input">
                            <input
                                v-model="formValues.otherVenueType"
                                :class="formErrors.otherVenueType.error ? 'invalid-input' : ''"
                                type="text"
                                maxlength="25"
                                placeholder="Specify"
                            />
                            <div v-if="formErrors.otherVenueType.error" class="input-err-msg">
                                {{ formErrors.otherVenueType.msg }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="venue-description-input">
                    <div class="labels">
                        <p class="title">Venue Story</p>
                        <p class="subtitle">
                            This is your chance to tell your story. What`s your vibe? Who is
                            your audience? What`s your venue`s personality?
                        </p>
                    </div>
                    <div class="description-input">
                        <textarea
                            v-model="formValues.venueDescription"
                            :class="formErrors.venueDescription.error ? 'invalid-input' : ''"
                            name="venue-description"
                            placeholder="Describe your venue"
                        ></textarea>
                        <div v-if="formErrors.venueDescription.error" class="input-err-msg">
                            {{ formErrors.venueDescription.msg }}
                        </div>
                    </div>
                </div>
                <div v-if="compErrMsg" class="input-err-msg">{{ compErrMsg }}</div>
            </div>
        </popup-modal>
    </div>
</template>
<script>
    import axios from 'axios'
    import PopupModal from '@/components/user/login-popups/PopupModal.vue'
    import { venueTypes } from '../../../../user/venue-types'

    const URLS = {
        user: '/profile/v1/settings/user/',
        info: '/profile/v1/info/venue/'
    }

    const inputValid = {
        otherVenueType: (val) => val.length === 0 || val.length <= 25,
        venueDescription: (val) => val.length === 0 || val.length < 500
    }

    export default {
        name: 'VenueGenre',

        components: {
            'popup-modal': PopupModal
        },

        emits: ['closeModalAction'],

        data: () => ({
            compErrMsg: '',

            formValues: {
                otherVenueType: '',
                venueDescription: ''
            },

            formErrors: {
                otherVenueType: {
                    error: false,
                    msg: 'Please specify an others type, less than 255 characters.'
                },
                venueDescription: {
                    error: false,
                    msg: 'Please enter less than 500 characters.'
                }
            },

            venueTypes: venueTypes
        }),

        methods: {
            uncheckOthers(indx) {
                for (let i = 0; i < this.venueTypes.length; i++) {
                    if (i === indx) continue

                    this.venueTypes[i].selected = false
                }
            },

            clearErrors() {
                for (let i = 0; i < this.formErrors.length; i++) {
                    this.formErrors[i].error = false
                }
            },

            clearInputs() {
                for (let i = 0; i < this.venueTypes.length; i++) {
                    this.venueTypes[i].selected = false
                }

                this.formValues.venueDescription = ''
                this.formValues.otherVenueType = ''
                this.clearErrors()
            },

            validateInputs() {
                let isInputValid = true
                let keys = Object.keys(this.formErrors)

                for (let i = 0; i < keys.length; i++) {
                    if (!inputValid[keys[i]](this.formValues[keys[i]])) {
                        this.formErrors[keys[i]].error = true
                        isInputValid = false
                    } else {
                        this.formErrors[keys[i]].error = false
                    }
                }

                for (let i = 0; i < this.venueTypes.length; i++) {
                    if (
                        this.venueTypes[i].val === 6 &&
                        this.venueTypes[i].selected === true &&
                        !this.formValues.otherVenueType
                    ) {
                        this.formErrors.otherVenueType.error = true
                        isInputValid = false
                    }
                }

                return isInputValid
            },

            validate() {
                if (
                    this.formValues.venueDescription ||
                    this.venueTypes.filter((v) => v.selected).length
                ) {
                    return this.validateInputs()
                } else {
                    this.compErrMsg = '[422] : You must enter some values to continue.'
                    return false
                }
            },

            prepInfoData() {
                let data = {}
                let selectedType = this.venueTypes.filter((v) => v.selected)

                if (this.formValues.venueDescription) {
                    data.description = this.formValues.venueDescription
                }

                if (selectedType.length) {
                    data.venue_type = selectedType[0].val
                }

                if (data.venue_type === 6)
                    data.other_venue_type = this.formValues.otherVenueType

                return data
            },

            async handleSetAction() {
                this.clearErrors()

                if (this.validate()) {
                    let infoData = this.prepInfoData()

                    await this.updateInfo(infoData)
                    this.$emit('closeModalAction')
                } else {
                    return
                }
            },

            handleCancelAction() {
                this.clearInputs()
                this.$emit('closeModalAction')
            },

            async updateInfo(data) {
                try {
                    let userResp = await axios.get(this.URLS.user)
                    let userId = userResp.data.data[0].id

                    let infoResp = await axios.post(this.URLS.info + userId, {
                        _method: 'PUT',
                        ...data
                    })
                    return infoResp
                } catch (err) {
                    this.compErrMsg = `[${err.response?.status}] : ${err.response?.data?.message}`
                    throw err
                }
            }
        },

        computed: {
            URLS: () => URLS
        }
    }
</script>
<style lang="scss" scoped>
    .popup-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        margin-left: 90px;

        .venue-type-input {
            margin-top: 50px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;

            .field-inputs {
                display: flex;
                flex-direction: row;
                row-gap: 10px;
                column-gap: 22px;
                flex-wrap: wrap;
                max-width: 987px;

                .venue-type {
                    flex: 0 0 auto;

                    input[type='checkbox'] {
                        border-radius: 5px;
                        border: 1.5px solid #8b8b8b;
                        background-color: transparent;
                        width: 20px;
                        height: 20px;
                    }

                    label {
                        color: #8b8b8b;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        font-family: Instrument Sans;
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 550;
                        line-height: 120%;
                        letter-spacing: -0.2px;
                    }
                }

                input[type='text'] {
                    min-width: 391px;
                    padding: 12px 15px 15px 15px;
                    color: #8b8b8b;
                    border-radius: 12px;
                    border: 1.5px solid #8b8b8b;
                    background: #262626;
                    font-family: Instrument Sans;
                    font-size: 20px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 120%;
                    letter-spacing: -0.2px;
                }

                input[type='text']::placeholder {
                    color: #8b8b8b;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-family: Instrument Sans;
                    font-size: 20px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 120%;
                    letter-spacing: -0.2px;
                }
            }
        }
        .venue-description-input {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            margin-top: 72px;
            gap: 16px;

            textarea {
                min-width: 545px;
                min-height: 202px;
                padding: 12px 15px 15px 15px;
                border-radius: 12px;
                border: 1.5px solid #8b8b8b;
                background: #262626;
                color: #8b8b8b;
                color: #8b8b8b;
                font-family: Instrument Sans;
                font-size: 20px;
                font-style: normal;
                font-weight: 550;
                line-height: 120%;
                letter-spacing: -0.2px;
            }
        }

        .title {
            color: #dedede;
            font-family: Instrument Sans;
            font-size: 44px;
            font-style: normal;
            font-weight: 500;
            line-height: 110%;
            letter-spacing: -1.76px;
            margin-bottom: 0px;
        }

        .subtitle {
            margin-top: 22px;
            color: #acacac;
            font-family: Instrument Sans;
            font-size: 16px;
            font-style: normal;
            font-weight: 550;
            line-height: 125%;
        }
    }
</style>
